var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h4',{staticClass:"m-5"},[_vm._v(_vm._s(_vm.$t('home.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('home.text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }